import { CoordinateSource, ILocation, ILuggage, ITimePeriod, StorageCriteria } from '@luggagehero/shared/interfaces';
import { SharedUtilDate } from '@luggagehero/shared/util';

export class SharedStorageCriteria implements StorageCriteria {
  public constructor(
    public location?: ILocation,
    public period?: ITimePeriod,
    public luggage?: ILuggage,
    public activeOnly = true,
    public coordinateSource?: CoordinateSource,
  ) {}

  public toString(): string {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const loc = this.location as ILocation;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const per = this.period as ITimePeriod;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const lug = this.luggage as ILuggage;
    const where = `'${loc.address}' [${this.formatLatLon(loc)}] ${loc.type}`;
    const when = `${this.formatDate(per.from)} - ${this.formatDate(per.to)}`;
    const what = `${lug.normal}/${lug.hand}`;
    return `${where} | ${when} | ${what}`;
  }

  /**
   * Compare this `ShopCriteria` instance with another one
   * @param other The other `ShopCriteria` instance to compare with
   * @param includeTime Whether to include the time in the comparison
   * @returns `true` if the two `ShopCriteria` instances are equal, `false` otherwise
   */
  public equals(other: SharedStorageCriteria, includeTime = false): boolean {
    if (!other) {
      return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const thisLoc = this.location as ILocation;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const otherLoc = other.location as ILocation;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const thisLug = this.luggage as ILuggage;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const otherLug = other.luggage as ILuggage;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const thisPer = this.period as ITimePeriod;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    const otherPer = other.period as ITimePeriod;

    // Compare the location
    if (thisLoc.address !== otherLoc.address || thisLoc.lat !== otherLoc.lat || thisLoc.lon !== otherLoc.lon) {
      return false;
    }

    // Compare the luggage
    if (thisLug.normal !== otherLug.normal || thisLug.hand !== otherLug.hand) {
      return false;
    }

    if (includeTime) {
      return thisPer.from.getTime() === otherPer.from.getTime() && thisPer.to.getTime() === otherPer.to.getTime();
    }

    return SharedUtilDate.isSameDate(thisPer.from, otherPer.from) && SharedUtilDate.isSameDate(thisPer.to, otherPer.to);
  }

  private formatDate(value: Date): string {
    return value.toISOString().substring(0, 16).replace('T', ' ');
  }

  private formatLatLon(value: ILocation): string {
    return `${value.lat.toFixed(2)},${value.lon.toFixed(2)}`;
  }
}
